// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { PropTypes } from 'react';
import { merge } from "lodash/fp";
import Input from 'share/components/controls/Izenda.Input';

/**
 * Extend column definition object to apply "select all" checkbox
 * @param {any} columnDefinition
 * @param {function} onChange handler
 * @param {boolean} checked
 * @returns {any} extended column definition.
 */
export function extendColumnDefinitionProps(columnDefinition, onChange, checked, disabled) {
  const props = {
    onChange: onChange,
    isChecked: !!checked,
    isDisabled: !!disabled,
    title: columnDefinition.title
  };
  return merge(columnDefinition, {
    headerComponent: SelectAllColumn,
    headerComponentProps: props
  });
}

/**
 * Column header with "select all" checkbox.
 */
function SelectAllColumn({onChange, isChecked, isDisabled, title}) {
  const onCheckedHandler = (evt: any) => {
    !isDisabled && onChange && onChange(evt.target.checked);
  };

  return (
    <span>
      <div>
        <a className="unsort" title={title}>{title}</a>
      </div>
      <Input className="u_marginTop"
             type="checkbox"
             checked={isChecked}
             disabled={isDisabled}
             onChange={onCheckedHandler} />
    </span>
  );
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.SelectAllColumn.js